import { Title } from './Title';
export function PageHeading(props) {
    return <Title appearance="page" as="h2" {...props}/>;
}
